import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white py-8" data-id="element-174">
      <div className="container mx-auto px-4" data-id="element-175">
        <div className="max-w-5xl mx-auto" data-id="element-176">
          <div className="text-center mb-6" data-id="element-177">
            <div className="font-serif text-xl mb-2" data-id="element-178">The Health Times</div>
            <p className="text-sm text-gray-400" data-id="element-179">
              Investigating Health Solutions
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-180">
            <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-181">
              Terms & Conditions
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-182">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-183">
              About Us
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-184">
              Contact
            </a>
          </div>
          <div className="text-center text-sm text-gray-500" data-id="element-185">
            <p className="mb-2" data-id="element-186">
              This article is for informational purposes only. This is not
              medical advice. Statements regarding dietary supplements have not
              been evaluated by the FDA and are not intended to diagnose, treat,
              cure, or prevent any disease or health condition.
            </p>
            <p data-id="element-187">
              © {new Date().getFullYear()} The Health Times. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}